module.exports = __webpack_public_path__ + "img/kulungileMetals.6b74db27.jpg";